import request from '@/common/request/request';
import {handleRes} from '@vUtils';

interface HandleResInterface {
  success: any;
  fail: any;
}

function isBizOk(res: any): boolean {
  return res && (res.code === 200 || res.code === 0);
}

function wrapRes(res: any, failMes?: string): HandleResInterface {
  if (isBizOk(res)) {
    const data = res.data !== undefined && res.data !== null ? res.data : true;
    return {
      success: data,
      fail: undefined,
    };
  }
  const result = handleRes(res, {
    failMes: failMes || res.msg,
  });
  return result;
}

/** 文件列表 GET /open-resource/file */
const getFileList = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['GETOpen-resourceFile'](params);
    const result = wrapRes(res, res.msg);
    if (result.success && typeof result.success === 'object') {
      const rows = result.success.rows || result.success.list || [];
      const total = result.success.total || 0;
      result.success = {
        rows: Array.isArray(rows) ? rows : [],
        total: total,
      };
    } else if (!result.success) {
      result.success = false;
    }
    resolve(result);
  });
};

/** 新增文件 POST /open-resource/file */
const addFile = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['POSTOpen-resourceFile'](params);
    resolve(wrapRes(res, res.msg));
  });
};

/** 修改文件 PUT /open-resource/file */
const updateFile = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['PUTOpen-resourceFile'](params);
    resolve(wrapRes(res, res.msg));
  });
};

/** 删除文件 DELETE /open-resource/file */
const deleteFile = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['DELETEOpen-resourceFile'](params);
    resolve(wrapRes(res, res.msg));
  });
};

/** 菜单树 GET /open-resource/menu */
const getMenu = (params?: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['GETOpen-resourceMenu'](params || {});
    if (isBizOk(res)) {
      let menu = [];
      if (res.data && Array.isArray(res.data.menu)) {
        menu = res.data.menu;
      } else if (Array.isArray(res.menu)) {
        menu = res.menu;
      } else if (Array.isArray(res.data)) {
        menu = res.data;
      }
      resolve({
        success: { menu: menu },
        fail: undefined,
      });
      return;
    }
    resolve(wrapRes(res, res.msg));
  });
};

/** 新增菜单 POST /open-resource/menu */
const addMenu = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['POSTOpen-resourceMenu'](params);
    resolve(wrapRes(res, res.msg));
  });
};

/** 修改菜单 PUT /open-resource/menu */
const updateMenu = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['PUTOpen-resourceMenu'](params);
    resolve(wrapRes(res, res.msg));
  });
};

/** 删除菜单 DELETE /open-resource/menu */
const deleteMenu = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request['DELETEOpen-resourceMenu'](params);
    resolve(wrapRes(res, res.msg));
  });
};

const openResource = {
  getFileList,
  addFile,
  updateFile,
  deleteFile,
  getMenu,
  addMenu,
  updateMenu,
  deleteMenu,
};

export default openResource;
